import React from "react";
import TableHeader from "./TableHeader";
import TableBody from "./TableBody";
import "./styles/table.css";

const Table = ({
  className,
  columns,
  idPropName,
  idPropName2,
  selectedItemId,
  selectedItemId2,
  sortColumn,
  onSort,
  data,
  handleClick_tr,
  disableAllSort,
  isPaginated,
  currPage,
  pageCount,
  getNextPage,
  fetching,
}) => {
  return (
    <table className={className}>
      <TableHeader
        columns={columns}
        sortColumn={sortColumn}
        onSort={onSort}
        disableAllSort={disableAllSort}
      />
      <TableBody
        columns={columns}
        data={data}
        idPropName={idPropName}
        idPropName2={idPropName2}
        selectedItemId={selectedItemId}
        selectedItemId2={selectedItemId2}
        handleClick_tr={handleClick_tr}
        isPaginated={isPaginated}
        currPage={currPage}
        pageCount={pageCount}
        getNextPage={getNextPage}
        fetching={fetching}
      />
    </table>
  );
};

export default Table;
